import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Chip } from '@mui/material';
import type { ChipColor } from '@/types/chip';
import { Gavel } from '@mui/icons-material';
import { CASE_STAGE_COLORS } from './constants';

interface DisciplinaryRecord {
  id?: string;
  caseNumber?: string;
  description?: string;
  incidentDate?: string;
  currentStage?: string;
  outcome?: string;
  warningType?: string;
  [key: string]: unknown;
}

interface EmployeeDisciplinaryProps {
  records: DisciplinaryRecord[];
}

export const EmployeeDisciplinary = ({ records }: EmployeeDisciplinaryProps) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <Gavel color="primary" />
      <Typography variant="subtitle1" fontWeight={700}>Disciplinary Cases</Typography>
      <Chip label={`${records.length} records`} size="small" sx={{ ml: 1 }} />
    </Box>
    {records.length > 0 ? (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Case #</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Incident Date</TableCell>
            <TableCell>Stage</TableCell>
            <TableCell>Outcome</TableCell>
            <TableCell>Warning Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map(d => (
            <TableRow key={d.id}>
              <TableCell><Chip label={d.caseNumber} size="small" /></TableCell>
              <TableCell>{d.description?.substring(0, 50)}{(d.description?.length ?? 0) > 50 ? '...' : ''}</TableCell>
              <TableCell>{d.incidentDate}</TableCell>
              <TableCell><Chip label={d.currentStage} size="small" color={CASE_STAGE_COLORS[d.currentStage ?? ''] as ChipColor} /></TableCell>
              <TableCell>{d.outcome || '—'}</TableCell>
              <TableCell>{d.warningType || '—'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    ) : (
      <Typography variant="body2" color="text.secondary">No disciplinary cases found</Typography>
    )}
  </Box>
);
